import { Theme, useMediaQuery } from '@mui/material';

export function useIsMobile(): boolean {
  return useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
}